import CommonFieldName from "./CommonFieldName";

enum CompanyFieldName {
  NAME = CommonFieldName.NAME,
  ADDRESS = "address",
  CITY = "city",
  REGION = "region",
  POSTAL_CODE = "postalCode",
  COUNTRY = "countryCode",
  PHONE = "phone",
  WEBSITE = "website",
  CRM_LINK = CommonFieldName.CRM_LINK,
  EMAIL = CommonFieldName.EMAIL,
  FILES = CommonFieldName.FILES,
  GROUPS = CommonFieldName.GROUPS,
  COLOR = CommonFieldName.COLOR,
  ANNUAL_REVENUE = "annualRevenue",
  NUM_EMPLOYEES = "numEmployees",
  CREATOR = CommonFieldName.CREATOR,
  CREATOR_NAME = CommonFieldName.CREATOR_NAME,
  CREATOR_EMAIL = CommonFieldName.CREATOR_EMAIL,
  USER = CommonFieldName.USER,
  OWNER_NAME = CommonFieldName.OWNER_NAME,
  OWNER_EMAIL = CommonFieldName.OWNER_EMAIL,
  NEXT_ACTIVITY = CommonFieldName.NEXT_ACTIVITY,
  LAST_ACTIVITY_DATE = CommonFieldName.LAST_ACTIVITY_DATE,
  LAST_ACTIVITY_TYPE = CommonFieldName.LAST_ACTIVITY_TYPE,
  LAST_ACTIVITY_NAME = CommonFieldName.LAST_ACTIVITY_NAME,
  FREQUENCY_STATUS = CommonFieldName.FREQUENCY_STATUS,
  FREQUENCY_INTERVAL = CommonFieldName.FREQUENCY_INTERVAL,
  DAYS_LEFT_IN_FREQUENCY = CommonFieldName.DAYS_LEFT_IN_FREQUENCY,
  NO_CONTACT_IN = CommonFieldName.NO_CONTACT_IN,
  NOTES = CommonFieldName.NOTES,
  UNIQUE_ID = CommonFieldName.UNIQUE_ID,
  GEOPOINT = CommonFieldName.GEOPOINT,
  LATITUDE = "latitude",
  LONGITUDE = "longitude",
  SOURCE = CommonFieldName.SOURCE,
  SOURCE_OBJECT = CommonFieldName.SOURCE_OBJECT,
  PARENT_COMPANY = "parentAccount",
  PARENT_COMPANY_ADDRESS = "parentAccount.address",
  PERSON = "contactId", // normally only used for company creation and never after
  CREATED_AT = CommonFieldName.CREATED_AT,
  UPDATED_AT = CommonFieldName.UPDATED_AT,
  TEAM = CommonFieldName.TEAM,
  TERRITORIES = CommonFieldName.TERRITORIES,
  VIEW_AS = CommonFieldName.VIEW_AS,
  ROUTES = "routes",
  PARENT_COMPANY_IMPORT_ID = "parentAccount.importId",
  NO_CHECK_IN = "noCheckIn",
  NO_VERIFIED_CHECK_IN = "noVerifiedCheckIn",
  PRIMARY_PERSON = "primaryContact",
}

export default CompanyFieldName;
